// extracted by mini-css-extract-plugin
module.exports = {"appLogo":"ReactLogo_appLogo__220Zs","App-logo-spin":"ReactLogo_App-logo-spin__1pN5e"};